<template>
    <div>
        <div class="card-body" v-loading="$parentInfo.studentPeriod.finishPeriod.loading">
            <el-form class="demo-ruleForm">
                <el-row :span="20">
                    <el-col :span="24">
                        <el-form-item label="上课内容">
                            <el-input v-model=$parentInfo.studentPeriod.finishPeriod.openFinishedPeriod.content
                                      type="textarea"
                                      :autosize="{ minRows: 2, maxRows: 4}" placeholder="上课内容"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="上课认真程度">
                            <el-rate
                                    v-model=$parentInfo.studentPeriod.finishPeriod.openFinishedPeriod.serious_degree
                                    show-text
                                    text-color="#ff9900"
                                    :colors="['#99A9BF', '#F7BA2A', '#FF9900']"></el-rate>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="笔记记录程度">
                            <el-rate v-model=$parentInfo.studentPeriod.finishPeriod.openFinishedPeriod.note_degree
                                     show-text
                                     text-color="#ff9900"
                                     :colors="['#99A9BF', '#F7BA2A', '#FF9900']"></el-rate>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="复习程度">
                            <el-rate v-model=$parentInfo.studentPeriod.finishPeriod.openFinishedPeriod.review_degree
                                     show-text
                                     text-color="#ff9900"
                                     :colors="['#99A9BF', '#F7BA2A', '#FF9900']"></el-rate>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" align="right">
                <el-button type="danger" size="small" @click=handleFinishedPeriod(1)
                           :loading=$parentInfo.studentPeriod.finishPeriod.button_loading>
                    需要回访
                </el-button>
                <el-button type="primary" size="small" @click=handleFinishedPeriod(0)
                           :loading=$parentInfo.studentPeriod.finishPeriod.button_loading>
                    保存
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        props: {
            classPlanStudent_id: {
                default: 0
            },
        },
        methods: {
            handleFinishedPeriod(returnVisit) {
                this.$parentInfo.studentPeriod.finishPeriod.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'storeFinishedPeriod', {
                    'classPlanStudent_id': this.classPlanStudent_id,
                    'content': this.$parentInfo.studentPeriod.finishPeriod.openFinishedPeriod.content,
                    'serious_degree': this.$parentInfo.studentPeriod.finishPeriod.openFinishedPeriod.serious_degree,
                    'note_degree': this.$parentInfo.studentPeriod.finishPeriod.openFinishedPeriod.note_degree,
                    'review_degree': this.$parentInfo.studentPeriod.finishPeriod.openFinishedPeriod.review_degree,
                    'status': this.$parentInfo.studentPeriod.finishPeriod.openFinishedPeriod.status,
                    'returnVisit': returnVisit,
                    'student_id':this.$parentInfo.student_id,
                });
            },
        }
    };
</script>
